import { useDispatch, useSelector } from 'react-redux'

import { caseActions } from '../../../../store/case'
import InputBox from '../../../common/interactive/InputBox'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import InputBoxCurrency from '../../../common/interactive/InputBoxCurrency'
import DefaultUpdater from '../../../common/DefaultUpdater'

import classes from './MajorMedPayments.module.css'

const MajorMedPayments = ({itemData, apiCase}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const updateHandler = async (data) => {
       
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        setTimeout(() => {
            dispatch(caseActions.modifyActiveCase({
                folder: 'major_meds',
                item: {
                    itemId: itemData.id,
                    field: data.identifier.field,
                    value: data.data.value,
                },
            }))
        }, 0)

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }        
        
    }

    return <div className={classes.container}>
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th>Office Copay</th>
                    <th>Specialty Copay</th>
                    <th>Coinsurance</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>OON</td>
                    <td>
                        <DefaultUpdater type={'curency'} value={itemData.office_copay_oon} name={'available_hra'} identifier={{type: apiCase, field: 'office_copay_oon', type_id: itemData.id, folder: 'major_meds'}} extraOptions={{placeholder: 'OON $', textRight: true}}/>
                    </td>
                    <td>
                        <DefaultUpdater type={'curency'} value={itemData.speciality_copay_oon} name={'speciality_copay_oon'} identifier={{type: apiCase, field: 'speciality_copay_oon', type_id: itemData.id, folder: 'major_meds'}} extraOptions={{placeholder: 'OON $', textRight: true}}/>
                    </td>
                    <td>
                        <DefaultUpdater type={'input'} value={itemData.coinsurance_oon} identifier={{type: apiCase, field: 'coinsurance_oon', type_id: itemData.id, folder: 'major_meds'}} extraOptions={{placeholder: 'OON %', format: '100max', maxNumericValue: 100, setStyle: 'simple'}}/>
                    </td>
                </tr>
                <tr>
                    <td>INN</td>
                    <td>
                        <InputBoxCurrency placeholder={'INN $'} name={'office_copay_inn'} action={updateHandler} identifier={{type: apiCase, field: 'office_copay_inn', type_id: itemData.id}} currentValue={itemData.office_copay_inn} textRight={true}/>
                    </td>
                    <td>
                        <InputBoxCurrency placeholder={'INN $'} name={'speciality_copay_inn'} action={updateHandler} identifier={{type: apiCase, field: 'speciality_copay_inn', type_id: itemData.id}} currentValue={itemData.speciality_copay_inn} textRight={true}/>
                    </td>
                    <td>
                        <InputBox bkTransparent={true} placeholder={'INN %'} currentValue={itemData.coinsurance_inn} format={'100max'} maxNumericValue={100} setStyle={'simple'} action={updateHandler} identifier={{type: apiCase, field: 'coinsurance_inn', type_id: itemData.id, setStyle: 'simple'}} />
                    </td>
                </tr>
            </tbody>
        </table>

        <table>
            <thead>
                <tr>
                    <th>Deductibles</th>
                    <th>**Remaining</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <InputBoxCurrency placeholder={'OON $'} name={'deductible_oon'} action={updateHandler} identifier={{type: apiCase, field: 'deductible_oon', type_id: itemData.id}} currentValue={itemData.deductible_oon} textRight={true}/>
                    </td>
                    <td>
                        <InputBoxCurrency placeholder={'OON $'} name={'remaining_1_oon'} action={updateHandler} identifier={{type: apiCase, field: 'remaining_1_oon', type_id: itemData.id}} currentValue={itemData.remaining_1_oon} textRight={true}/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <InputBoxCurrency placeholder={'INN $'} name={'deductible_inn'} action={updateHandler} identifier={{type: apiCase, field: 'deductible_inn', type_id: itemData.id}} currentValue={itemData.deductible_inn} textRight={true}/>
                    </td>
                    <td>
                        <InputBoxCurrency placeholder={'INN $'} name={'remaining_1_inn'} action={updateHandler} identifier={{type: apiCase, field: 'remaining_1_inn', type_id: itemData.id}} currentValue={itemData.remaining_1_inn} textRight={true}/>
                    </td>
                </tr>
            </tbody>
        </table>

        <table>
            <thead>
                <tr>
                    <th>Out of Pocket Max</th>
                    <th>**Remaining</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <InputBoxCurrency placeholder={'OON $'} name={'out_pocket_max_oon'} action={updateHandler} identifier={{type: apiCase, field: 'out_pocket_max_oon', type_id: itemData.id}} currentValue={itemData.out_pocket_max_oon} textRight={true}/>
                    </td>
                    <td>
                        <InputBoxCurrency placeholder={'OON $'} name={'remaining_2_oon'} action={updateHandler} identifier={{type: apiCase, field: 'remaining_2_oon', type_id: itemData.id}} currentValue={itemData.remaining_2_oon} textRight={true} />
                    </td>
                </tr>
                <tr>
                    <td>
                        <InputBoxCurrency placeholder={'INN $'} name={'out_pocket_max_inn'} action={updateHandler} identifier={{type: apiCase, field: 'out_pocket_max_inn', type_id: itemData.id}} currentValue={itemData.out_pocket_max_inn} textRight={true} />
                    </td>
                    <td>
                        <InputBoxCurrency placeholder={'INN $'} name={'remaining_2_inn'} action={updateHandler} identifier={{type: apiCase, field: 'remaining_2_inn', type_id: itemData.id}} currentValue={itemData.remaining_2_inn} textRight={true} />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

}

export default MajorMedPayments